var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89 7.902 2.137 9.963a.183.183 0 0 1-.263-.046.206.206 0 0 1-.026-.174l1.016-3.387a.203.203 0 0 0-.068-.218L.076 4.025a.204.204 0 0 1-.039-.276c.035-.05.09-.08.15-.08l3.383-.032a.19.19 0 0 0 .177-.135L4.82.135A.187.187 0 0 1 5.06.01c.056.02.1.066.119.125l1.074 3.367a.19.19 0 0 0 .177.135l3.383.032c.104 0 .188.09.187.2 0 .061-.029.12-.076.156l-2.72 2.113a.203.203 0 0 0-.067.218l1.016 3.387a.2.2 0 0 1-.123.248.181.181 0 0 1-.166-.028L5.11 7.903a.181.181 0 0 0-.218 0z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.760fe387c66e89ecfe9e74e0e28c5414.svg";
export { ForwardRef as ReactComponent };